interface Params {
  offerId: string;
}

export const getFetchOfferUrl = ({ offerId }: Params): string =>
  `/offers/${offerId}`;
